import { Component, EventEmitter, Input, Output, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { NgIf } from '@angular/common';
import { RouterLink } from '@angular/router';
import { LegFiJwtService } from '../../../../services/auth/legfi-jwt.service';
import { PennyHowItWorksDialogComponent } from '../../../v2-layout/other-tools/ai-chatbot/how-it-works-dialog/penny-how-it-works-dialog.component';

/** Read-only AI chatbot status (SD-9449); configuration lives at /app/other-tools/ai-chatbot. */
@Component({
    selector: 'app-wb-ai-chatbot-status-card',
    templateUrl: './wb-ai-chatbot-status-card.component.html',
    styleUrls: ['./wb-ai-chatbot-status-card.component.scss'],
    standalone: true,
    imports: [
        NgIf,
        RouterLink,
        PennyHowItWorksDialogComponent,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class WbAiChatbotStatusCardComponent {
    @Input() enabled = false;
    @Input() center = false;
    @Input() showConfigure = true;
    /** Fires as the Configure button navigates, so a host dialog can step aside. */
    @Output() configure = new EventEmitter<void>();

    // The config route demands website-builder write, so read-only members get the status without a link that would bounce them.
    readonly canConfigure = LegFiJwtService.doesUserHaveModulePermission('website-builder', true);

    howItWorksOpen = false;
}
